<template>

    <div v-if="isLoaded">
        <div class="object-info__inner accordion-body__inner request-table-inner request-table-inner--scroll
             		request-table-inner--five-cells js-entity-info-container js-copy-mobile-container" v-for="(account, idxAcc) in adata">
            <div v-if="!account.IsBlocked" class="object object--account object--account-entity block js-scroll-here">
                <div class="object__table entity-header">
                    <div class="object__cell object__cell--left h5">
                        <div class="object__cell-row">
                            <label class="cb-input">
                                <input class="cb-input__checkbox" type="checkbox" data-toggle-account="" v-on:change="AccFlag(idxAcc)" v-model="account.isFlag">
                                <span v-if="account.isFlagVisible" class="cb-input__check"></span>
                                <span v-if="account.TerminationDate!=''" class="cb-input__label object__value status-error h2">{{account.AccountNumber}}</span>
                                <span v-else class="cb-input__label object__value status-primary h2">{{account.AccountNumber}}</span>
                            </label>
                            <span class="status-primary">(Открыт {{account.BeginDate}})</span>
                            <span v-if="account.TerminationDate!=''" class="status-error">(Закрыт {{account.TerminationDate}})</span>
                        </div>
                        <div class="object__value object__cell-row">
                            <div class="object__value-row">
                                <span class="object__value-name">Адрес: </span>{{account.City}}, {{account.Address}}
                            </div>
                            <div class="object__value-row">
                                <span class="object__value-name">ИКУ: </span>{{account.UK}}
                            </div>
                        </div>
                    </div>
                    <div class="object__cell object__cell--md entity-header__account h5">
                        <div class="object__cell-row-mobile">
                            <div class="object__label">Баланс по ЛС:</div>
                            <div v-if="account.TerminationDate!=''" class="object__value status-error h3">{{account.TotalDebt}} ₽</div>
                            <div v-if="account.TerminationDate=='' && account.TotalDebt>0" class="object__value status-primary h3">{{account.TotalDebt}} ₽</div>
                            <div v-if="account.TerminationDate=='' && account.TotalDebt<=0" class="object__value status-success h3">{{account.TotalDebt}} ₽</div>
                        </div>
                        <div class="object__icon-container">
                            <a :href="'#objectMessage_*'+account.PersonAccountId" class="v-menu__link link js-message-toggle js-collapse-toggle" data-toggle="collapse" data-scroll-to="">
                                <div class="link__icon fab-icon" style="color: #dfd3d3;">
                                    <i class="icon icon--email"></i>
                                    <!--

                                    <div class="fab-icon__label">23</div>

                                    -->
                                </div>
                            </a>
                            <a href="#" href0="/requestlist/" class="v-menu__link link">
                                <div class="link__icon fab-icon" style="color: #dfd3d3;">
                                    <i class="icon icon--request"></i>
                                    <!--

                                    <div class="fab-icon__label">4</div>

                                    -->
                                </div>
                            </a>
                            <a href="/profiles/settings" class="v-menu__link link">
                                <div class="link__icon fab-icon fab-icon--blue-hover">
                                    <i class="icon icon--setting"></i>
                                </div>
                            </a>
                        </div>
                    </div>
                    <div @click="hidePacketPay">
                        <account-buttons :account=account :idxAcc="idxAcc" @updateIdxShow="updateIdxShow"></account-buttons>
                    </div>
                </div>
            </div>

            <div v-else class="object object--account object--account-entity block js-scroll-here">
                <div class="object__table entity-header">
                    <div class="object__cell object__cell--left h5">
                        <div class="object__cell-row">
                            <label class="cb-input">
                                <input class="cb-input__checkbox" type="checkbox" data-toggle-account="">
                                <span class="cb-input__check"></span>
                                <!--<span v-if="account.TerminationDate!=''" class="cb-input__label object__value status-error h2">{{account.AccountNumber}}</span>
                                <span v-else class="cb-input__label object__value status-primary h2">{{account.AccountNumber}}</span>-->
                                <span class="cb-input__label object__value status-primary h2">{{account.AccountNumber}}</span>
                            </label>
                            <!--<span class="status-primary">(Открыт {{account.BeginDate}})</span>
                            <span v-if="account.TerminationDate!=''" class="status-error">(Закрыт {{account.TerminationDate}})</span>-->
                        </div>
                        <div class="object__value object__cell-row">
                            <div class="object__value-row">
                                <span class="object__value-name">Адрес: </span><!--{{account.City}}, {{account.Address}}-->
                            </div>
                            <div class="object__value-row">
                                <span class="object__value-name">ИКУ: </span><!--{{account.Iku}}-->
                            </div>
                        </div>
                    </div>
                    <div class="object__cell object__cell--md entity-header__account h5">
                        <div class="object__cell-row-mobile">
                            <div class="object__label">Баланс по ЛС:</div>
                            <!--<div v-if="account.TerminationDate!=''" class="object__value status-error h3">{{account.TotalDebt}} ₽</div>
                            <div v-if="account.TerminationDate=='' && account.TotalDebt>0" class="object__value status-primary h3">{{account.TotalDebt}} ₽</div>
                            <div v-if="account.TerminationDate=='' && account.TotalDebt<=0" class="object__value status-success h3">{{account.TotalDebt}} ₽</div>-->
                        </div>
                        <div class="object__icon-container">
                            <a :href="''" class="v-menu__link link js-message-toggle js-collapse-toggle" data-toggle="collapse" data-scroll-to="">
                                <div class="link__icon fab-icon" style="color: #dfd3d3;">
                                    <i class="icon icon--email"></i>
                                </div>
                            </a>
                            <a href="#" href0="/requestlist/" class="v-menu__link link">
                                <div class="link__icon fab-icon" style="color: #dfd3d3;">
                                    <i class="icon icon--request"></i>
                                </div>
                            </a>
                            <a href="/profiles/settings" class="v-menu__link link">
                                <div class="link__icon fab-icon fab-icon--blue-hover">
                                    <i class="icon icon--setting"></i>
                                </div>
                            </a>
                        </div>
                    </div>
                    <account-buttons :account=account></account-buttons>
                </div>
            </div>

            <account-autopayment :account=account></account-autopayment>
            <account-epd :account=account></account-epd>
            <div class="block" v-if="idxAcc==idxShowPay">
                <div class=" object__form-inner pay-list__submit">
                    <div class="line-form b-form">
                        <account-pay @UpdateManSum="UpdateManSum" :idxShowPay="idxShowPay" :account=account :cards=cards :key="payKey" :checkAgreement="checkAgreement" @updateAgree="updateAgree" ref="Pay"></account-pay>
                        <account-recalc :account=account :updateTotal="updateTotal" @updateSum="updateSum" @updateTitle="updateTitle" ref="Recalc"></account-recalc>
                    </div>
                </div>
            </div>
            <account-paymentprocedure :account=account></account-paymentprocedure>

            <div class="accordion-body accordion-body--message js-messages-container collapse" :id="'objectMessage_'+account.PersonAccountId">
                <div class="accordion-body__inner message-slider block">
                    <div class="message-slider__head">
                        <div class="message-slider__title h3">
                            <span>Информационные уведомления:</span>
                            <a :href="'#objectMessage_'+account.PersonAccountId" class="button-icon button-icon--th-main message-slider__close-btn" data-toggle="collapse"><i class="icon icon--close"></i></a>
                        </div>
                        <div class="message-date-slider js-message-date-slider swiper-container">
                            <div class="message-date-slider__wrapper swiper-wrapper">
                                <div class="message-date-slider__slide swiper-slide">
                                    <div class="subnav__item">
                                        <button class="subnav__link link h4 js-message-dates is-active" data-button-url="../messages-chosen.php">
                                            Показать избранные
                                        </button>
                                    </div>
                                </div>
                                <div class="message-date-slider__slide swiper-slide">
                                    <div class="subnav__item">
                                        <button class="subnav__link link h4 js-message-dates" data-button-url="../messages.php">
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="message-slider__right">
                            <div class="message-slider__ctrl slider-ctrl">
                                <a href="" class="slider-ctrl__button button-icon button-icon--th-slider js-message-prev"><i class="icon icon--angle-left"></i></a>
                                <a href="" class="slider-ctrl__button button-icon button-icon--th-slider js-message-next"><i class="icon icon--angle-right"></i></a>
                            </div>
                        </div>
                    </div>
                    <div class="message-slider__body swiper-container js-message-slider">
                        <div class="swiper-wrapper js-message-wrapper">

                            <div class="entity-message message-slider__item swiper-slide js-message-container">
                                <div class="entity-message__star icon-star is-active js-star-icon">
                                </div>
                                <div class="entity-message__date">18 февраля 2021</div>
                                <div class="entity-message__title h5">
                                    Заголовок этот текст условный, ничего не значащий текст, который просто вставляется в макет для демонстрации картинки и заполнения блока
                                </div>
                                <div class="entity-message__text">
                                    Текст сообщения, этот текст условный, ничего не значащий текст, который просто вставляется в макет для демонстрации картинки и заполнения блока, что часто используется в печати и веб-дизайне.Lorem ipsum — классический текст-«рыба». Является искажённым отрывком из философского трактата Марка Туллия ...
                                </div>
                                <div class="entity-message__btn-inner">
                                    <div class="entity-message__btn button button--th-help js-message-read">Прочитано</div>
                                    <a href="" class="button button--th-second">Подробнее</a>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div v-if="idxShowPay<0" :id="'oI_'+account.BspId+'_'+account.PersonAccountId" class="object-info accordion-body collapse">
                <!-- если нет столбца перерасчет - добавляется класс request-table-inner--without-recalculations -->
                <div class="object-info__inner accordion-body__inner request-table-inner request-table-inner--scroll
							request-table-inner--five-cells	js-entity-info-container js-copy-mobile-container">
                    <div class="object-info__section object-info__section--line object-info__section--desctop block">
                        <div class="request-table__row request-table__row--account h5 js-copy-mobile-item">
                            <div class="request-table__cell request-table__cell--max request-table__cell--desctop">
                                <period-slider :account=account :refreshProductsData="refreshProductsData"></period-slider>

                                <div v-if="isReadyToPdf(account)" class="doc-help-container js-form-payment is-doc" v-on:click="getPdf(account)"
                                     v-bind:style="isReadyToPdf(account) ? 'cursor:pointer' : 'cursor:not-allowed'"
                                     v-bind:class="isReadyToPdf(account) ? '' : 'is-disable'"
                                     :key="payKey">
                                    <div class="doc-help">
                                        <div class="doc-help__icon js-form-payment-doc">
                                            <img src="/images/fl/check.svg" alt="">
                                        </div>
                                        <div class="doc-help__drop">
                                            <div class="doc-help__inner">Получить pdf-версию платежного документа за период, по которому завершены расчеты</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--<div class="request-table__cell"></div>-->
                            <!--<div class="request-table__cell">К оплате <br>на {{account.CalcData.CalcDateStart}}, ₽</div>-->
                            <div class="request-table__cell">Задолженность <br>на {{account.CalcData.CalcDateStart}}, ₽</div>
                            <div class="request-table__cell request-table__cell--max">Начисления и Перерасчеты, ₽</div>
                            <!--<div class="request-table__cell request-table__cell--max">Перерасчеты, ₽</div>-->
                            <div class="request-table__cell request-table__cell--max">Оплачено, ₽</div>
                            <div class="request-table__cell request-table__cell--last">{{tit}}<br> на {{account.CalcData.CalcDate}}, ₽</div>
                            <a :href="'#oI_'+account.BspId+'_'+account.PersonAccountId" class="button-icon button-icon--th-primary request-table__close" data-toggle="collapse">
                                <i class="icon icon--close"></i>
                            </a>
                        </div>
                    </div>
                    <div>
                        <account-products v-if="idxShowPay<0" :account=account :cards=cards :updateTotal="updateTotal" @updateSum="updateSum" @updateTitle="updateTitle" ref="Prod"></account-products>
                        <div v-if="idxShowPay<0" class="block">
                            <div class=" object__form-inner pay-list__submit">
                                <div class="line-form b-form">
                                    <account-pay @UpdateManSum="UpdateManSum" :idxShowPay="idxShowPay" :account=account :cards=cards :key="payKey" :checkAgreement="checkAgreement" @updateAgree="updateAgree" ref="Pay"></account-pay>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--Пакетная оплата-->
        <div v-if="isPacketPay" class="block" style="margin-top: 28px; border: thin solid rgb(230,230,230);">
            <div class=" object__form-inner pay-list__submit">
                <div class="line-form b-form">
                    <!--<account-packet-pay @UpdateManSum="UpdateManSum" :idxShowPay="idxShowPay" :account=account :cards=cards :key="payKey" :checkAgreement="checkAgreement" @updateAgree="updateAgree" ref="Pay"></account-packet-pay>-->
                    <account-packet-pay :adata=adata :cards=cards ref="Packet"></account-packet-pay>
                </div>
            </div>
        </div>
        <!--Информация о картах-->
        <div class="block" style="margin-bottom: 18px; border: thin solid rgb(230,230,230); border-top:none;">
            <div class="object__info pay-info block">
                <div class="pay-info__ctrl">
                    <a href="#payInfoDetail" class="collapse-link link link--underline" data-toggle="collapse" aria-expanded="true">
                        <span class="link__text h4">Информация об оплате банковской картой</span>
                        <span class="link__icon fab-icon">
                            <i class="icon icon--angle-down"></i>
                        </span>
                    </a>
                </div>
                <div class="pay-info__types">
                    <div class="pay-info__item">
                        <img src="/images/pay-types/visa.png" alt="">
                    </div>
                    <div class="pay-info__item">
                        <img src="/images/pay-types/visa-verified.png" alt="">
                    </div>
                    <div class="pay-info__item">
                        <img src="/images/pay-types/mastercard.png" alt="">
                    </div>
                    <div class="pay-info__item">
                        <img src="/images/pay-types/mastercard-secure.png" alt="">
                    </div>
                    <div class="pay-info__item">
                        <img src="/images/pay-types/mir.png" alt="">
                    </div>
                    <div class="pay-info__item">
                        <img src="/images/pay-types/mir-acept.png" alt="">
                    </div>
                    <div class="pay-info__item">
                        <img src="/images/pay-types/unionPay.png" alt="">
                    </div>
                </div>
            </div>
            <div id="payInfoDetail" class="pay-info-body accordion-body collapse" aria-expanded="true" style="">
                <div class="accordion-body__inner block">
                    <div class="editor ex-small">
                        <h2>К оплате принимаются следующие типы банковских карт:</h2>
                        <ul class="list-divide">
                            <li><h3>VISA, имеющие трехзначный код CVV2;</h3></li>
                            <li><h3>Mastercard, имеющие трехзначный код CVС2;</h3></li>
                            <li><h3>МИР, имеющие трехзначный код на обратной стороне.</h3></li>
                        </ul>
                        <h5>В случае успешной авторизации Вы получите от сайта уведомление о том, что оплата проведена и/или описание порядка получения товара/услуги.</h5>
                        <p>В рамках технологии интернет-эквайринга возврат денежных средств возможен исключительно по реквизитам банковской карты с которой проводилась оплата.</p>
                        <p>Безопасность платежей обеспечивается с помощью Банка-эквайера (ГАЗПРОМБАНК (Акционерное Общество)), функционирующего на основе современных протоколов и технологий, разработанных платежными системами МИР, Visa International и Mastercard Worldwide (3D-Secure: Verified by VISA, Mastercard SecureCode, MirAccept).</p>
                        <p>Обработка полученных конфиденциальных данных Держателя карты производится в процессинговом центре Банка, сертифицированного по стандарту PCI DSS. Безопасность передаваемой информации обеспечивается с помощью современных протоколов обеспечения безопасности в сети Интернет.</p>
                        <p>При оплате данные Вашей пластиковой карты вводятся на платежной странице Банка с использованием защищенного канала. Информация передаётся в зашифрованном виде и обрабатывается только на специализированном сервере банка.</p>
                        <p>После нажатия кнопки «Оплатить» Вы будете направлены на защищенную платежную страницу процессингового центра Банка, где необходимо ввести данные пластиковой карты.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <div class="js-load-testimony main-preloader main-preloader--first main-preloader" style="display:block">
            <span class="main-preloader__item main-preloader__item--first"></span>
            <span class="main-preloader__item main-preloader__item--second"></span>
            <span class="main-preloader__item main-preloader__item--third"></span>
        </div>
    </div>

</template>


<script type="text/javascript">

    import AccountButtons from './account-buttons.vue';
    import AccountAutopayment from './account-autopayment.vue';
    import AccountEpd from './account-epd.vue';
    import PeriodSlider from './period-slider.vue';
    import AccountPaymentprocedure from './account-paymentprocedure.vue';
    import AccountPay from './account-pay.vue';
    import AccountPacketPay from './account-packet-pay.vue';
    import AccountProducts from './account-products.vue';
    import AccountRecalc from './account-recalc.vue'
    import { setTimeout } from "core-js";

    export default {
        components: {
            AccountButtons,
            AccountAutopayment,
            AccountEpd,
            PeriodSlider,
            AccountPaymentprocedure,
            AccountPay,
            AccountPacketPay,
            AccountProducts,
            AccountRecalc
        },
        props: {
        },
        data: function () {
            return {
                isPacketPay: false,
                isLoaded: false,
                componentKey: 0,
                accounts: Array,
                cards: Array,
                adata: [],
                payKey: 0,
                sum: 0,
                accKey: 1000,
                refreshHandler: null,
                checkAgreement: false,
                handlers: new Map(),
                getPdfHandler: null,
                tit: 'К оплате',
                idxShowPay: -1
            }
        },
        computed: {
            maxyear: function () { var d = new Date(); return d.getFullYear(); },
            maxmonth: function () { var d = new Date(); return d.getMonth() + 1; }
        },
        methods: {
            hidePacketPay: function () {
                if (this.isPacketPay) {
                    this.isPacketPay = false;
                    for (var idx in this.adata) {
                        this.adata[idx].isFlag = false;
                        this.adata[idx].isFlagVisible = true;
                    }
                }
                return true;
            },
            AccFlag: function (index) {
                if (this.adata[index].isFlag)
                    // Флаг установлен.
                    for (var idx in this.adata) {
                        //if (this.adata[index].isStek) {
                        //    this.adata[idx].isFlagVisible = (idx == index);
                        //    if (idx != index) this.adata[idx].isFlag = false;
                        //}
                        //else {
                        this.adata[idx].isFlagVisible = (this.adata[index].BspId == this.adata[idx].BspId);
                        if (this.adata[index].BspId != this.adata[idx].BspId) this.adata[idx].isFlag = false;
                    }
                var cnt = 0;
                for (var idx in this.adata)
                    if ((this.adata[idx].isFlag) && (this.adata[idx].BspId == this.adata[index].BspId))
                        cnt++;
                if (cnt == 0)
                    for (var idx in this.adata)
                        this.adata[idx].isFlagVisible = true;
                this.isPacketPay = (cnt > 1);
                if (cnt > 1) {
                    this.idxShowPay = -1;
                    if (this.$refs.Packet)
                        this.$refs.Packet.recalcAccouns();
                }
                this.$forceUpdate();
            },
            UpdateManSum: function (newSum) {
                this.$refs.Recalc[0].recalcSsum(newSum);
            },
            updateIdxShow: function (newIndex) {
                this.idxShowPay = newIndex;
            },
            loadData: function () {
                var self = this;
                axios.get('/fl/accounts/getAccounts')
                    .then(function (response) {
                        var data = JSON.parse(response.data);
                        self.accounts = data.Accounts;
                        self.adata = data.Accounts;
                        // Сброс флагов со всёх счетов при загрузке getAccounts.
                        for (var index in self.adata) {
                            self.adata[index].isFlag = false;
                            self.adata[index].isFlagVisible = true;
                        }
                        self.cards = JSON.parse(data.Cards);
                        self.componentKey += 1;
                        self.AddToPayProd();

                        self.$nextTick(() => {
                            window.setTimeout(function () {
                                var url = document.URL.split('#');
                                if (url.length > 1 && url[1].includes('oI_')) {
                                    $("#" + url[1].replace('oI_', 'btn_')).click();
                                    if (document.getElementById(url[1])) document.getElementById(url[1]).scrollIntoView({ block: "center", behavior: "smooth" });
                                }
                            }, 1000);
                        });

                        // Начальная установка флажков начислений "сброшен" на всей странице счетов.
                        window.setTimeout(function () {
                            /*const elements = document.querySelectorAll(".accruals-checkbox");
                            for (var i = 0; i < elements.length; i++) {
                                elements[i].click();
                            }*/
                            /*
                            var elements = document.getElementsByClassName("accruals-checkbox");
                            for (var index in elements) {
                                console.log(index, elements[index]);
                                elements[index].change();
                            }
                            */
                        }, 4000);
                        self.isLoaded = true;
                        // -------------------------------------------------------------------------
                    })
                    .catch(function (error) {
                        console.log('Ошибка получения данных: ' + error.message);
                        self.componentKey += 1;
                        self.isLoaded = true;
                    });
            },
            isReadyToPdf: function (Account) {
                if (Account.InProcess == true) {
                    return false;
                }
                if (Account.EpdStartDate == null)
                    return false;

                var year = Account.currentYear;
                var month = Account.currentMonth;

                if (month == undefined) {
                    return false;
                }
                if (year == undefined) {
                    return false;
                }
                var currentDateStart = new Date(year, month, 1);
                var currentDateEnd = new Date(year, month - 1, 1);
                return (currentDateStart >= new Date(Account.EpdStartDate) && currentDateEnd <= new Date(Account.EpdEndDate))
            },
            updateSum: function () {
                for (var idx in this.$refs.Pay) {
                    this.$refs.Pay[idx].calc();
                }
            },
            updateAgree: function (newAgree) {
                this.checkAgreement = newAgree;
            },
            updateTitle: function (newVal) {
                //this.tit = (newVal) ? 'Задолженность' : 'К оплате';
            },
            updateTotal: function () {
                this.payKey++;
            },
            getPdf: function (Account) {

                if (!this.isReadyToPdf(Account)) {
                    return;
                }

                var self = this;
                console.log('getPdf ', Account.BspId, Account.PersonAccountId);

                var year = Account.currentYear;
                var month = Account.currentMonth;
                var accountNumber = Account.AccountNumber;

                if (self.maxyear == year && month == self.maxmonth) {
                    console.log('maxYear ');
                    return;
                }

                console.log('month && year', month, year);
                if (month > 0 && year > 0) {

                    var _handler = self.handlers.get(Account.PersonAccountId + '/' + year + '/' + month);
                    if (_handler != undefined) {
                        return;
                    }
                    self.handlers.set(Account.PersonAccountId + '/' + year + '/' + month, 0);
                    console.log('Формирование ЕПД | ', Account.BspId, Account.PersonAccountId, month, year);
                    axios.get('/fl/accounts/orderepd/' + Account.BspId + '/' + Account.PersonAccountId + '/' + year + '/' + month)
                        .then(function (response) {
                            console.log('Формирование ЕПД | response = ', response);
                            if (response.data !== 'error' && response.data !== '') {
                                const fileName = '' + accountNumber + '_' + year + '_' + month + '.pdf';
                                var handler = response.data;
                                console.log('Формирование ЕПД | handler = ', handler);
                                Account.InProcess = true;
                                self.payKey++;
                                self.handlers.set(Account.PersonAccountId + '/' + year + '/' + month,
                                    setInterval(() => {
                                        axios.get('/fl/accounts/getepd/' + handler + '/' + Account.BspId, {
                                            responseType: 'blob',
                                            timeout: 30000,
                                        })
                                            .then(function (response) {
                                                if (response.data == '') {
                                                    console.log('wait..');
                                                }
                                                else {
                                                    Account.InProcess = false;
                                                    self.payKey++;
                                                    if (response.data.size > 0) {

                                                        clearInterval(self.handlers.get(Account.PersonAccountId + '/' + year + '/' + month));
                                                        self.handlers.set(Account.PersonAccountId + '/' + year + '/' + month, null);
                                                        self.handlers.delete(Account.PersonAccountId + '/' + year + '/' + month);

                                                        console.log('..ready');

                                                        let a = window.document.createElement('a');
                                                        a.href = window.URL.createObjectURL(response.data);
                                                        a.download = fileName;
                                                        document.body.append(a);
                                                        a.click();
                                                        console.log('..download');
                                                    }
                                                    else {
                                                        console.log('..data size = 0');
                                                    }
                                                }
                                            })
                                            .catch(function (error) {
                                                Account.InProcess = false;
                                                self.payKey++;
                                                console.log('Ошибка получения данных: ' + error.message);
                                            });
                                    }, 5000)
                                );
                                setTimeout(() => {
                                    if (self.handlers.get(Account.PersonAccountId + '/' + year + '/' + month) > 0) {

                                        clearInterval(self.handlers.get(Account.PersonAccountId + '/' + year + '/' + month));
                                        self.handlers.set(Account.PersonAccountId + '/' + year + '/' + month, null);
                                        self.handlers.delete(Account.PersonAccountId + '/' + year + '/' + month);

                                        console.log('..stop');
                                    }
                                }, 50000);

                            }
                            else {
                                console.log('Формирование ЕПД невозможно, повторите запрос позднее');
                            }
                        })
                        .catch(function (error) {
                            console.log('Ошибка формирования ЕПД: ' + error.message);
                            self.handlers.delete(Account.PersonAccountId + '/' + year + '/' + month);
                        });
                }
                else {
                    console.log('error ', month, year, self.getPdfHandler);
                    self.handlers.delete(uaccount + '/' + year + '/' + month);
                }
            },
            refreshProductsData: function (bspid, uaccount, year, month) {
                var self = this;

                if (self.refreshHandler != null) {
                    clearTimeout(self.refreshHandler);
                }
                var a = self.accounts;
                var accountToChange = null;
                for (var i = 0; i < a.length; i++) {
                    if (a[i].PersonAccountId == uaccount) {
                        a[i].InProcess = true;
                        accountToChange = a[i];
                        self.payKey++;
                    }
                };

                self.refreshHandler = setTimeout(() => {
                    axios.get('/fl/accounts/productcalc/' + bspid + '/' + uaccount + '/' + year + '/' + month)
                        .then(function (response) {
                            for (var i = 0; i < a.length; i++) {
                                if (a[i].PersonAccountId == uaccount) {
                                    a[i].CalcData = JSON.parse(response.data);
                                    a[i].currentYear = year;
                                    a[i].currentMonth = month;
                                }
                            };
                            self.adata = a;
                            self.AddToPayProd();

                            if (accountToChange != null) {
                                accountToChange.InProcess = false;
                            }

                            self.payKey++;

                            window.setTimeout(function () {
                                for (var idx in self.$refs.Prod) {
                                    self.$refs.Prod[idx].calcRowsSaldoEnd();
                                    self.$refs.Prod[idx].calcSum();
                                }
                            }, 1000);
                        })
                        .catch(function (error) {
                            console.log('Ошибка получения данных: ' + error.message);
                            if (accountToChange != null) {
                                accountToChange.InProcess = false;
                            }
                            self.payKey++;
                        });
                }, 512);
            },
            AddToPayProd: function () {
                for (var a in this.adata)
                    for (var p in this.adata[a].CalcData.Products) {
                        var prod = this.adata[a].CalcData.Products[p];
                        prod.IsUserPay = false;
                        prod.ToPayCheck = true;
                        //prod.AccrualsCheck = true;
                        var sum = prod.SaldoBegin
                            // + prod.Recalculation
                            - prod.Paid;
                        if (prod.AccrualsCheck) {
                            sum += prod.Accruals;
                        }
                        if (sum < 0) sum = 0;
                        else
                            sum = Math.round(sum * 100) / 100
                        prod.ToPayProd = sum;
                    }
            }


        },
        mounted() {
            this.loadData();
        }
    };
</script>



// WEBPACK FOOTER //
// Scripts/app/fl/components/IndividualAccounts.vue